import { render, staticRenderFns } from "./PinForm.vue?vue&type=template&id=56b1a9f4&scoped=true"
import script from "./PinForm.vue?vue&type=script&lang=ts"
export * from "./PinForm.vue?vue&type=script&lang=ts"
import style0 from "./PinForm.vue?vue&type=style&index=0&id=56b1a9f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1a9f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b1a9f4')) {
      api.createRecord('56b1a9f4', component.options)
    } else {
      api.reload('56b1a9f4', component.options)
    }
    module.hot.accept("./PinForm.vue?vue&type=template&id=56b1a9f4&scoped=true", function () {
      api.rerender('56b1a9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ota/PinForm.vue"
export default component.exports